"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDTypeList = void 0;
__exportStar(require("./components/UserAudioComponent"), exports);
__exportStar(require("./components/UserImageComponent"), exports);
__exportStar(require("./components/UserMCQComponent"), exports);
__exportStar(require("./components/UserBooleanComponent"), exports);
__exportStar(require("./components/UserTextComponent"), exports);
__exportStar(require("./components/UserVideoComponent"), exports);
__exportStar(require("./components/UserAudioSegmentationComponent"), exports);
__exportStar(require("./components/UserAudioMarkerComponent"), exports);
__exportStar(require("./components/UserTextSelectComponent"), exports);
__exportStar(require("./components/UserTagsComponent"), exports);
__exportStar(require("./components/UserOpenComponent"), exports);
__exportStar(require("./components/UserMultiTextSelectComponent"), exports);
__exportStar(require("./components/UserAudioTranscriptionComponent"), exports);
__exportStar(require("./components/UserReferWorkerComponent"), exports);
__exportStar(require("./components/UserDateComponent"), exports);
__exportStar(require("./components/UserImageAnnotationComponent"), exports);
__exportStar(require("./components/UserFullInBlanksComponent"), exports);
__exportStar(require("./components/UserWordCloudComponent"), exports);
__exportStar(require("./components/UserIdCaptureComponent"), exports);
__exportStar(require("./components/UserLocaleBooleanComponent"), exports);
__exportStar(require("./components/UserPRPTextComparisonComponent"), exports);
__exportStar(require("./components/UserConferencerVoipCallerComponent"), exports);
exports.userDTypeList = {
    TEXT: 'Text',
    AUDIO: 'Audio',
    MCQ: 'Multiple Choice',
    IMAGE: 'Image',
    VIDEO: 'Video',
    BOOLEAN: 'Boolean',
    AUDIO_SEGMENTATION: 'Audio Segmentation',
    AUDIO_MARKER: 'Audio Timestamp Marker',
    OPEN: 'Open',
    TEXT_SELECT_MULTI: 'Text Select Multi',
    AUDIO_TRANSCRIPTION: 'Audio Transcription',
    DATE: 'Date',
    IMAGE_ANNOTATION: 'Image Annotation',
    FILL_BLANK: 'Fill in the Blanks',
    USER_ID_CAPTURE: 'User ID Capture',
    TEXT_SELECT: 'Text Select',
    TAGS: 'Tags',
    REFER_WORKER: 'Refer Worker',
    WORD_CLOUD: 'Word Cloud',
    LOCALE_BOOLEAN: 'Locale Boolean',
    PRP_TEXT_COMPARISON: 'Prompt Response Pairs Text Comparison',
    CONFERENCER_VOIP_CALLER: 'Conferencer Caller Voip Based',
};
//# sourceMappingURL=Index.js.map